import { render } from "./mobile_menu_subgroup.vue?vue&type=template&id=16d3d9a0&scoped=true"
import script from "./mobile_menu_subgroup.vue?vue&type=script&lang=js"
export * from "./mobile_menu_subgroup.vue?vue&type=script&lang=js"

import "./mobile_menu_subgroup.vue?vue&type=style&index=0&id=16d3d9a0&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./mobile_menu_subgroup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d3d9a0"]])

export default __exports__